module.exports = __webpack_public_path__ + "src/assets/img/share/level2/7ceff7e1c6223f8fbacaf1e83fa622bf.png";